import { render, staticRenderFns } from "./CourseFloatThumb.vue?vue&type=template&id=9164ccf2&scoped=true"
import script from "./CourseFloatThumb.vue?vue&type=script&lang=js"
export * from "./CourseFloatThumb.vue?vue&type=script&lang=js"
import style0 from "./CourseFloatThumb.vue?vue&type=style&index=0&id=9164ccf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9164ccf2",
  null
  
)

export default component.exports